import React, {useState, useEffect} from "react";

import {Table} from "../../../common/table/Table";
import {retrieveAllIndicators} from "../../../../services/IndicatorService";

export const IndicatorTable = ({context, setContext, navigateTo, showToaster, setSpinnerText}) => {

    const [indicators, setIndicators] = useState([]);

    useEffect(() => {
        setSpinnerText("Fetching Indicators");
        const fetchData = async () => {
            const [data, error] = await retrieveAllIndicators(context.username);
            if (data) {
                if (data.responseStatus === "Success") {
                    setIndicators(data.indicatorVOList);
                } else {
                    showToaster(data);
                }
            } else {
                showToaster({
                    responseStatus: "Error",
                    responseMessage: error.message,
                });
            }
            setSpinnerText(null);
        }
        fetchData();
    }, []);

    const handleRowClick = (indicator) => {
        const indicatorToBeEdited = {
            externalReference: indicator.externalReference,
            indicator: indicator.indicator,
            topicArea: {topicArea: indicator.topicArea, externalReference: indicator.topicAreaExternalReference},
            outcomeMeasure: indicator.outcomeMeasure,
            numerator: indicator.numerator,
            denominator: indicator.denominator,
            active: indicator.active,
        };
        setContext((prevState) => ({
            ...prevState,
            selectedIndicator: indicatorToBeEdited,
        }));
        navigateTo("indicatorCapture");
    }

    const handleAddButtonClick = () => {
        setContext((prevState) => ({
            ...prevState,
            selectedIndicator: null,
        }));
        navigateTo("indicatorCapture");
    }

    return (
        <div className="admin-table-container">
            <Table tableData={indicators} searchEnabled={true} buttonText={"Add Indicator"}
                   onButtonClick={handleAddButtonClick} onRowClick={handleRowClick}
                   hiddenColumns={["externalReference", "topicAreaExternalReference", "isDeleted", "created", "lastModified"]}/>
        </div>
    )
}
